import {
  getProfileCommonAPI,
} from '@/js/services/cabinet'

export const cabinet = {
  namespaced: true,
  state: {
    profileCommon: {},
    emailCommon: {},
  },
  getters: {
    profileCommon: state => state.profileCommon,
    emailCommon: state => state.emailCommon,
  },
  actions: {
    /**
     * Data arrives during initialization js.
     * @param { Function } commit
     */
    getProfileCommonAPI({ commit }) {
      return getProfileCommonAPI.execute({})
        .then(response => {
          const COMMON = {
            companyName: response.data.item.companyName,
            phone: response.data.item.phone,
            firstName: response.data.item.firstName,
            lastName: response.data.item.lastName,
          }
          const EMAILS = {
            email: response.data.item.email,
          }
          commit('setProfileCommon', COMMON)
          commit('setEmailCommon', EMAILS)
        })
    },
  },
  mutations: {
    setProfileCommon: (state, data) => (state.profileCommon = data),
    setEmailCommon: (state, data) => (state.emailCommon = data),
  },
}



// WEBPACK FOOTER //
// ./src/js/store/modules/cabinet/core.js